import 'firebase/compat/auth';

import firebase from 'firebase/compat/app';

export const firebaseApp = firebase;
